import { SendbirdChatWith } from "@sendbird/chat";
import { GroupChannelModule } from "@sendbird/chat/groupChannel";

// For testing purposes:
// const APP_ID = "9DA1B1F4-0BE6-4DA8-82C5-2E81DAB56F23";

// For real use:
const APP_ID = "091F0D1E-D7DD-455F-9D1B-A98549DAFCAD";

const master_api_token = "5f24ed0bc34ee0866596f27046c7dbef89a81339";

// send sendbird message
const sendMessage = async (
  sb: SendbirdChatWith<GroupChannelModule[]>,
  channelUrl: string,
  message: string
) => {
  try {
    const channel = await sb.groupChannel.getChannel(channelUrl);

    const params = {
      message: message,
    };

    await channel.sendUserMessage(params);
  } catch (error) {
    console.log("Error initializing Sendbird: ", error);
  }
};

export { APP_ID, master_api_token, sendMessage };
